import styled from "styled-components";
import {
  PageContentHeader,
  PageContentHeaderActionsWrapper,
  PageContentWrapper,
} from "../../../styles/page";
import { ContentBodyWrapper, ContentWrapper } from "../../../styles/popup";

export const MainWrapper = styled(PageContentWrapper)`
  padding: 4px 20px 38px;
  font-family: Pretendard;
  border-radius: 20px;
  background: #f0f3f8;
  height: auto;
  > .table-wrapper {
    display: flex;
    flex-direction: column;
    > .header {
      display: flex;
      flex-direction: row;
      width: 100%;
      > .item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        color: #121212;
        font-family: Pretendard;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .item.z {
        margin: 0 41px;
      }

      > .item.a {
        width: 440px;
      }
      > .item.b {
        flex: 1.3;
      }
      > .item.c {
        flex: 1;
      }
      > .item.d {
        flex: 1;
        font-weight: 600;
      }
      > .item.e {
        flex: 1;
      }
      > .item.f {
        flex: 1;
      }
    }

    > .list-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;

      > .data-wrapper.selected {
        background: #7f25fb;

        > .item {
          color: #fff;
        }

        > .item.a {
          > .des {
            background-color: white;
            color: #7f25fb;
          }
          > .des.end {
            background-color: white;
          }
          > .des.starting {
            background-color: white;
          }
          > .des.stop {
            background-color: white;
          }
          > .des.lv {
            background-color: white;
          }
        }
      }
      > .data-wrapper {
        width: 100%;
        display: flex;
        flex-direction: row;
        border-radius: 15.04px;
        background: #fff;
        cursor: pointer;

        > .item {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 56px;
          color: var(--kakao-logo, #000);
          text-align: center;
          font-family: Pretendard;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        > .item.z {
          background: #d9d9d9;
          border-radius: 50%;
          width: 34px;
          height: 34px;
          margin: 10px 33px 0 15px;
          > img {
            cursor: pointer;
          }
        }
        > .item.a {
          width: 440px;

          > span {
            width: 100%;
            text-align: center;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-word;
            line-height: 1.3;
          }
        }
        > .item.b {
          flex: 1.3;
        }
        > .item.c {
          flex: 1;
        }
        > .item.d {
          flex: 1;
          font-weight: 600;
        }
        > .d.res {
          cursor: pointer;
        }
        > .item.e {
          flex: 1;
        }
        > .item.f {
          flex: 1;
        }
      }
    }
  }
`;

export const MainHeaderWrapper = styled(PageContentHeader)`
  background-color: #f0f3f8;
  margin-top: 30px;
  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
export const MainHeaderActionsWrapper = styled(PageContentHeaderActionsWrapper)`
  > .searchBox {
    display: flex;
    align-items: center;
    width: 292px;
    height: 50px;
    border: 1px solid #ccc;
    border-radius: 15px;
    background-color: #fff;
    padding: 0 15px;
    box-sizing: border-box;

    > input {
      flex: 1;
      border: none;
      outline: none;
      font-size: 16px;
    }

    input::placeholder {
      color: #b7b7b7;
    }

    .searchIcon {
      width: 40px;
      height: 40px;
      cursor: pointer;
      text-align: right;
      line-height: 40px;
    }
  }

  > .add-button {
    width: 184px;
    height: 50px;
    padding: 0px 29px;
    line-height: 50px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    border-radius: 15px;
    background-color: #7f25fb;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
  }
`;

export const EditTournamentContentWrapper = styled(ContentWrapper)`
  width: 1531px;
  height: 901.064px;
`;

export const EditTournamentWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 13.489px;
  display: flex;
  flex-direction: column;

  > .header {
    > span {
      color: #121212;
      font-family: Pretendard;
      font-size: 23.606px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    > img {
      width: 17px;
      height: 17px;
    }
    margin-top: 34.4px;
    margin-bottom: 18.3px;
    padding: 0 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  > .body {
  }
`;
export const EditTournamentBody = styled(ContentBodyWrapper)`
  width: 100%;
  gap: 62px;
  margin-bottom: 33.72px;

  > .config-wrapper {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    margin-right: 49.23px;
    flex: 1;
    > .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 836.3px;
      height: 38.444px;
      padding: 0 6.74px;
      border-radius: 30.35px;
      background: #2f3332;
      gap: 6.7px;
      > .item {
        cursor: pointer;
        flex: 1;
        height: 27.652px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--Black-200, #b7b7b7);
        text-align: center;
        font-family: Pretendard;
        font-size: 13.489px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      > .item.active {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 13.489px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        border-radius: 30.35px;
        background: var(--Purple-300, #6436e7);
      }
    }
  }

  > .preset-wrapper {
    margin-left: 40px;
    display: flex;
    flex-direction: column;

    > .title {
      color: #121212;
      font-family: Pretendard;
      font-size: 23.606px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 20.56px;
    }

    > .list-wrapper {
      display: flex;
      width: 522.698px;
      height: 629.936px;
      flex-direction: column;
      align-items: center;
      border-radius: 4.586px;
      background: #f0f0f0;
      position: relative;

      > .page-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        position: absolute;
        bottom: 17.13px;
        gap: 5.67px;

        > .button {
          cursor: pointer;
          display: flex;
          width: 22.661px;
          height: 22.661px;
          padding: 3.541px 2.494px 3.202px 2.833px;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          border-radius: 2.833px;
          border: 0.708px solid var(--Black-100, #f0f0f0);
          background: #fff;
          color: var(--Black-400, #444);
          text-align: center;
          font-family: Pretendard;
          font-size: 9.914px;
          font-style: normal;
          font-weight: 500;
          line-height: 14.163px; /* 142.857% */
        }

        > .button.disable {
          background: none;
        }

        > .button.select {
          border: 0.708px solid var(--Purple-300, #6436e7);
          color: var(--Purple-300, #6436e7);
        }
      }
      > .list-box {
        margin-top: 28.67px;
        display: flex;
        flex-direction: column;
        gap: 5.73px;
        > .item {
          cursor: pointer;
          border-radius: 11.466px;
          background: #fff;
          display: flex;
          flex-direction: row;
          width: 465.505px;
          height: 40.13px;
          align-items: center;
          justify-content: space-between;
          > .title {
            margin-left: 11.47px;
            color: #121212;
            font-family: Pretendard;
            font-size: 11.466px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
          > .info-wrapper {
            margin-right: 11.47px;
            display: flex;
            flex-direction: row;
            gap: 6px;
            align-items: center;

            > .box {
              padding: 4.5px 10.8px;
              border-radius: 5.733px;
              border: 1.147px solid var(--Purple-300, #6436e7);
              color: #121212;
              text-align: center;
              font-family: Pretendard;
              font-size: 11.466px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }
            > img {
              margin-left: 18.65px;
              width: 8.027px;
              height: 8.028px;
            }
          }
        }
      }
    }
  }
`;

export const EditTournamentBottom = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 40px;
  bottom: 16px;
  justify-content: center;

  > .button {
    cursor: pointer;
    width: 422.205px;
    height: 59.352px;
    border-radius: 30.35px;
    background: #969696;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .button.purple {
    background: var(--Purple-300, #6436e7);
  }
`;
